/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nothing_Here_YetInputs */

const en_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing here yet.`)
};

const es_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada aquí todavía.`)
};

const fr_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien ici pour le moment.`)
};

const de_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nichts hier.`)
};

const ja_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ何もありません。`)
};

const zh_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这里空空如也。`)
};

const ar_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد شيء هنا بعد.`)
};

const id_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada apa-apa di sini.`)
};

const it_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non c'è ancora nulla qui.`)
};

const ru_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь пока ничего нет.`)
};

const pt_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada aqui ainda.`)
};

const ko_nothing_here_yet = /** @type {(inputs: Nothing_Here_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 아무것도 없습니다.`)
};

/**
* | output |
* | --- |
* | "Nothing here yet." |
*
* @param {Nothing_Here_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nothing_here_yet = /** @type {((inputs?: Nothing_Here_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nothing_Here_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nothing_here_yet(inputs)
	if (locale === "es") return es_nothing_here_yet(inputs)
	if (locale === "fr") return fr_nothing_here_yet(inputs)
	if (locale === "de") return de_nothing_here_yet(inputs)
	if (locale === "ja") return ja_nothing_here_yet(inputs)
	if (locale === "zh") return zh_nothing_here_yet(inputs)
	if (locale === "ar") return ar_nothing_here_yet(inputs)
	if (locale === "id") return id_nothing_here_yet(inputs)
	if (locale === "it") return it_nothing_here_yet(inputs)
	if (locale === "ru") return ru_nothing_here_yet(inputs)
	if (locale === "pt") return pt_nothing_here_yet(inputs)
	return ko_nothing_here_yet(inputs)
});